module.exports = "https://coursera_assets.s3.amazonaws.com/images/91b019ffab1dc7a0d01c22f0d8477df6.png";